<template>
<div>
    <b-container v-if="progress_load_indicator" fluid class="ds-top-body text-left">
        <b-button-group class="mb-5">
            <b-button :pressed="display_filled_rate==false" :variant="display_filled_rate?'gray':'dark'" class="f-110" @click="changeProgressMode(false)">신청 및 제출 현황</b-button>
            <b-button :pressed="display_filled_rate==true" :variant="display_filled_rate?'dark':'gray'" class="f-110" @click="changeProgressMode(true)">답변 입력 현황</b-button>
        </b-button-group>        

        <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 class="mb-0 fw-600">  기업별 {{ display_filled_rate? `진행률` : `제출률` }}</h5>
            <b-button-group class="">
                <b-button :pressed="is_summary_mode_overall==true" :variant="is_summary_mode_overall?'dark':'gray'" class="" @click="is_summary_mode_overall=true"> 종합 </b-button>
                <b-button :pressed="is_summary_mode_overall==false" :variant="is_summary_mode_overall?'gray':'dark'" class="" @click="is_summary_mode_overall=false"> 상세보기 </b-button>
            </b-button-group>      
        </div>

        <div v-if="is_summary_mode_overall==true">
            <section>
                <!-- DS 표 규칙: 한 줄 머리 · 행 44 고정 · 칸마다 한 줄(넘치면 줄이고 전체는 title). 묶음 머리 '문항 부문별 …'는 부문 칸 title 로.
                     부문 칸 수가 질문지마다 달라 표 최소 폭은 계산해서 넘긴다(table_min_width) -->
                <b-table-simple responsive hover table-class="ds-table ds-table-fixed campaign-progress-table"
                                :style="{'--campaign-progress-min-width': table_min_width}">
                    <b-thead>
                        <b-tr>
                            <b-th class="ds-cell-no" style="width: 56px;">No.</b-th>
                            <b-th style="width: 160px;">프로젝트 코드</b-th>
                            <b-th>기업명</b-th>
                            <b-th style="width: 88px;">상태</b-th>
                            <template v-if="display_filled_rate==false">
                                <b-th v-for="stage in stage_dates" :key="stage.key" style="width: 100px;">{{ stage.label }}</b-th>
                            </template>
                            <!-- 정렬 머리 — 키보드로 누를 수 있게 버튼, 상태는 aria-sort. BootstrapVue 배경 화살표는 끄고 글자 옆 아이콘만, 좌우 16 은 여기서 -->
                            <b-th style="width: 200px; background-image: none; padding-left: 16px; padding-right: 16px;" :aria-sort="sort_step.aria">
                                <!-- 머리 글꼴 그대로(.btn 글꼴을 받지 않게 font: inherit) -->
                                <button type="button" class="btn btn-link p-0 text-reset text-decoration-none" style="font: inherit"
                                        :aria-label="`${rate_label} 정렬`" title="클릭하여 정렬"
                                        @click="toggleSorted(sort_step.next)">
                                    {{ rate_label }} <AppIcon :name="sort_step.icon" class="text-muted"/>
                                </button>
                            </b-th>
                            <!-- 부문 칸(64)은 좌우 8 — 코드가 없는 긴 부문명은 줄이고 전체는 title -->
                            <b-th v-for="(c_name, c_idx) in category_names" :key="c_idx" class="ds-cell-num"
                                  style="width: 64px; padding-left: 8px; padding-right: 8px;"
                                  :title="`문항 부문별 ${rate_label} · ${c_name}`">
                                <span class="ds-ellipsis">{{ category_name_to_code(c_name) }}</span>
                            </b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody v-if="is_progress_rate_loaded==true">
                        <b-tr v-for="(item, index) in sorted_target_companies" :key="`${item.project_code}-${item.company_id}`">
                            <b-td class="ds-cell-no">{{ index + 1 }}</b-td>
                            <b-td><span class="ds-ellipsis" :title="item.project_code">{{ item.project_code }}</span></b-td>
                            <b-td>
                                <span class="ds-ellipsis" :title="`${item.company_name} (${item.company_id})`">{{ item.company_name }} <span class="ds-sub">{{ item.company_id }}</span></span>
                            </b-td>
                            <b-td>
                                <span class="ds-status ds-ellipsis" :class="`ds-status-${statusTone(getNiceServiceStatus(item.company_id))}`"
                                      :title="statusLabel(getNiceServiceStatus(item.company_id))">{{ statusLabel(getNiceServiceStatus(item.company_id)) }}</span>
                            </b-td>
                            <!-- 시작일 · 제출일 · 결과배포일 — 시:분은 title, 지금 단계는 파란 글자 -->
                            <template v-if="display_filled_rate==false">
                                <b-td v-for="stage in stage_dates" :key="stage.key" class="ds-cell-nowrap" :title="getNiceServiceTimeStamp(item.company_id, stage.key)">
                                    <span :class="getNiceServiceStatus(item.company_id)==stage.key ? 'ds-status ds-status-primary' : 'ds-sub'">{{ getNiceServiceTimeStamp(item.company_id, stage.key, 'YY-MM-DD') }}</span>
                                </b-td>
                            </template>
                            <b-td>
                                <b-progress :class="display_filled_rate || totalRate(item.company_id)==100 ? 'thin-progress' : 'category-progress'" height="0.9rem">
                                    <b-progress-bar :value="totalRate(item.company_id)" :label="`${Math.floor(totalRate(item.company_id))}%`"></b-progress-bar>
                                </b-progress>
                            </b-td>
                            <b-td v-for="(c_name, c_idx) in category_names" :key="c_idx" class="ds-cell-num" style="padding-left: 8px; padding-right: 8px;">
                                {{ Math.floor(categoryRate(item.company_id)[c_name]) }}%
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </section>
        </div>
        <!-- 종합 끝 상세보기 시작 end of is_summary_mode_overall == true -->
        <!-- 종합 끝 상세보기 시작 end of is_summary_mode_overall == true -->
        <!-- 종합 끝 상세보기 시작 end of is_summary_mode_overall == true -->
        <!-- 종합 끝 상세보기 시작 end of is_summary_mode_overall == true -->
        
        <div v-else> 
            <section class="py-4 mb-5 bgray-100 d-flex align-items-stretch">
                <b-col class="col-3 col-xl-2 px-3 border-right border-color-gray-300">
                    <b-input-group> 
                        <b-form-input v-model="search_keyword" debounce="300" placeholder="기업 검색"></b-form-input>
                    </b-input-group>

                    <h6 class="mt-5 pb-1 border-bottom border-color-gray-300 f-90 fw-500 gray-500">전체 기업 ({{ temp_target_companies.length }}개사) </h6>
                    <div class="overflow-auto" style="max-height: 800px;">
                        <b-button v-for="(ztem, index) in filtered_companies" :key="index" block :variant="ztem.company_name == temp_target_companies[idx].company_name ?'icon-blue':'icon'" 
                        class="f-90 m-0 py-1 px-2 text-left overflow-hidden no-shadow" @click="selectCompany(ztem)"
                        > {{ ztem.company_name }}
                        </b-button>
                    </div>
                </b-col>
                <b-col class="col-9 col-xl-10 px-md-4">
                    <div class="f-110 fw-600 pb-2 border-bottom border-color-gray-300"> {{ temp_target_companies[idx].company_name }} {{ display_filled_rate? `진행률` : `제출률` }}</div>

                    <div v-if="display_filled_rate==true" class="d-flex flex-wrap justify-content-around align-items-center my-4">
                        <div class="total-progress-charter">
                            <!-- <progress-chart :category_name="`답변률 Total`" :progress_rate="getTotalFilledRate(temp_target_companies[idx].company_id)" :background_color="company_total_dounut" :key="re_total" class="total-progress-charter"></progress-chart> -->
                            <div :class="[getTotalFilledRate(temp_target_companies[idx].company_id) > 0 ? 'blue':'gray-600','total-progress-dounut-inner']"> 
                                <div class="f-85 gray-600">전체</div>
                                <span class="f-160 fw-600">{{ Math.round(getTotalFilledRate(temp_target_companies[idx].company_id))}}</span>% 
                            </div>
                        </div>
                        <div v-for="ca_name in category_names" :key="ca_name.id" class="progress-charter">
                            <!-- <progress-chart :category_name="ca_name" :progress_rate="getCategoryFilledRate(temp_target_companies[idx].company_id)[ca_name]" :background_color="company_category_dounut" :key="re_category" class="progress-charter"></progress-chart> -->
                            <div class="progress-dounut-inner"> 
                                <div class="f-85 gray-600">{{ ca_name }}</div>
                                <span class="f-120 fw-600">{{ Math.floor(getCategoryFilledRate(temp_target_companies[idx].company_id)[ca_name]) }}</span>%
                            </div>        
                        </div>
                        
                    </div>
                    <div v-else class="d-flex flex-wrap justify-content-around align-items-center my-4">
                        <div class="total-progress-charter">
                            <!-- <progress-chart :category_name="`제출률 Total`" :progress_rate="getTotalProgressRate(temp_target_companies[idx].company_id)" :background_color="company_total_dounut" :key="re_total" class="total-progress-charter"></progress-chart> -->
                            <div :class="[getTotalProgressRate(temp_target_companies[idx].company_id)> 0 ? 'blue':'gray-600','total-progress-dounut-inner']"> 
                                <div class="f-85 gray-600">전체</div>
                                <span class="f-160 fw-600">{{ Math.round(getTotalProgressRate(temp_target_companies[idx].company_id)) }}</span>% 
                            </div>                       
                        </div>
                        <div v-for="ca_name in category_names" :key="ca_name.id" class="progress-charter">
                            <!-- <progress-chart :category_name="ca_name" :progress_rate="getCategoryProgressRate(temp_target_companies[idx].company_id)[ca_name]" :background_color="company_category_dounut" :key="re_category" class="progress-charter"></progress-chart> -->
                            <div class="progress-dounut-inner"> 
                                <div class="f-85 gray-600">{{ ca_name }}</div>
                                <span class="f-120 fw-600">{{ Math.round(getCategoryProgressRate(temp_target_companies[idx].company_id)[ca_name]) }}</span>%
                            </div>        
                        </div>
                    </div>
                    <!-- <tree :data="temp_target_companies[idx].progress_contents" :prevent-select="false" :draggable="false" :space="1" :indent="0" class="px-2 px-lg-4 pb-4 clearfix overflow-auto">
                    <template v-slot="{data}">
                        <b-row
                        :class="[`node-level-${data._vm.level}`, 'mx-0 text-left border-bottom border-color-gray-300 d-flex align-items-stretch']" style="min-width:400px;">
                            <b-col :class="[`node-level-${data._vm.level}-sub`, 'col-7 col-md-8 py-1 pr-0 d-flex align-items-center']"> {{ data.question_name }} </b-col>
                            <b-col class="col-auto d-flex align-items-center text-center">
                                <span v-if="checkCompleted(data)!=''" :class ="[ checkCompleted(data) != '완료' ? 'on-completed':'on-track','fw-600']"> {{ checkCompleted(data) }} </span>
                                <fa v-if="checkCompleted(data)!='' && checkCompleted(data)== '완료'" :icon="['far','check-circle']" class="ml-1 gray-600"></fa>
                                <span v-else style="display: none;"></span>
                            </b-col>
                        </b-row>
                    </template>
                    </tree> -->
                </b-col>
            </section>
        </div> <!-- end of is_summary_mode_overall == false -->

    </b-container>
    <b-container v-else-if="load_error" fluid class="ds-top-body">
        <PageEmptyComponent compact :error="load_error" @retry="loadProgress" />
    </b-container>
    <b-container v-else-if="is_data_loaded && !sub_layout_loading" fluid class="ds-top-body">
        <PageEmptyComponent compact text="참여 기업이 없습니다." />
    </b-container>
    <b-container v-else fluid class="ds-top-body">
        <b-card class="my-5 border-0 blue text-center align-items-center"> <b-spinner class="mx-2 p-1 my-1" small type="grow"></b-spinner>진행률을 가져오고 있습니다... </b-card>
    </b-container>
    <hr class="border-0 bottom-space">

</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { getErrorMessage } from '@core/utils/api/errorMessage';
import PageEmptyComponent from '@shared_components/admin/components/common/PageEmptyComponent.vue';
import { PROGRESS_TONE } from '@shared_mixins/assessment.common.mixin.js';
// import ProgressChart from '@shared_components/admin/components/charts/ProgressChart'
// import CompanyFinder from '../managing_user/CompanyFinder'
// import {DraggableTree} from 'vue-draggable-nested-tree'
// import * as ih from '@core_utils/util'
// import * as th from 'tree-helper'
// import GeneralPrintButton from '@shared_components/admin/components/common/GeneralPrintButton'

// 상태 코드 → 표 안 상태 글자색 — 진행현황(ProjectProgress)과 같은 색(PROGRESS_TONE 의 한 글자 약어)
const STATUS_SHORT = {requested: '신', in_progress: '답', in_reprogress: '보', in_assessment: '평', completed: '완', canceled: '취'};

// 비율 정렬 단계(sorted) → 다음 단계 · aria-sort · 아이콘. 순서는 전과 같다: 기본(받은 순서) → 높은 순 → 낮은 순 → 기본
const SORT_STEPS = {
    'sort': {next: 'sort-down', aria: 'none', icon: 'arrows-sort'},
    'sort-down': {next: 'sort-up', aria: 'descending', icon: 'arrow-down'},
    'sort-up': {next: 'sort', aria: 'ascending', icon: 'arrow-up'}
};

export default {
    components:{
        PageEmptyComponent,
        // CompanyFinder,
        // ProgressChart,
        // 'tree': DraggableTree,
        // GeneralPrintButton
    },
    data() {
        return {
            category_names: [],
            local_template_tree_contents_original: [],

            // temp_target_companies: [{ company_code: 0, company_name: "Company a", total_progress: 30
            //category_progress: { category_A: 10, category_B: 20, category_C: 30, cateogry_D: 40 }, 
            //category_filled_rate: { category_A: 10, ... }, 
            //category_num_of_subs_init: { category_A: 10... }, 
            //category_num_of_filled: { category_A: 10...}, 
            //progress_contents: [ {category_a: 70 }, {category_b: 60}, {category_c: 55}, {category_d: 20} ]},
            //                { company_code: 1, company_name: "Company b", progress_a: 80, prgress_b: 55, progress_c: 45, progress_d: 80 },
            //                { company_code: 2, company_name: "Company c", progress_a: 40, prgress_b: 74, progress_c: 35, progress_d: 40 },
            //                { company_code: 3, company_name: "Company d", progress_a: 96, prgress_b: 50, progress_c: 52, progress_d: 10 }]

            is_data_loaded: false,
            load_error: '',

            is_progress_loaded: false,
            company_total_dounut: ['rgba(61, 90, 254, 1)'],
            company_category_dounut: ['rgba(173, 185, 255, 1)'],
            re_total: 0,
            re_category: 10,
            sorted: 'sort',
            // '신청 및 제출 현황' 의 단계 날짜 칸
            stage_dates: [
                {key: 'in_progress', label: '시작일'},
                {key: 'in_assessment', label: '제출일'},
                {key: 'completed', label: '결과배포일'}
            ]
        };
    },
    computed:{
        ...mapState('score', ['temp_target_companies']),
        ...mapState('admin', ['sub_layout_loading']),
        ...mapState('industry_campaigns', ['nice_services_status', 'category1_filled_rate', 'total_filled_rate', 'category1_progress_rate', 'total_progress_rate', 'is_progress_rate_loaded' ]),
        progress_load_indicator() {
            return this.is_data_loaded && this.temp_target_companies.length > 0;
        },
        campaign() {
            return this.$store.state.campaign;
        },
        campaign_id(){
            return this.$route.query.cmp ?? this.$route.query.campaign_id ?? this.campaign.campaign_id;
        },
        template_code(){
            return this.$route.query.template_code;
        },
        template_contents(){
            return this.$store.state.template_tree.template_contents;
        },
        // 보기 상태는 URL 에 둔다(새로고침·링크 공유 시 유지): rate=filled(답변 입력 현황), view=detail(상세보기), q(기업 검색), cpn(상세에서 고른 기업)
        display_filled_rate: {
            get() { return this.$route.query.rate === 'filled'; },
            set(value) { this.changeViewQuery({rate: value ? 'filled' : undefined}); }
        },
        is_summary_mode_overall: {
            get() { return this.$route.query.view !== 'detail'; },
            set(value) { this.changeViewQuery({view: value ? undefined : 'detail'}); }
        },
        search_keyword: {
            get() { return typeof this.$route.query.q === 'string' ? this.$route.query.q : ''; },
            set(value) { this.changeViewQuery({q: value || undefined}, true); }
        },
        idx() {
            const index = this.temp_target_companies.findIndex(x => String(x.company_id) === String(this.$route.query.cpn));
            return index > -1 ? index : 0;
        },
        filtered_companies(){
            const keyword = this.search_keyword.trim().toLowerCase();
            if (!keyword) return this.temp_target_companies;
            return this.temp_target_companies.filter(x => (x.company_name || '').toLowerCase().includes(keyword));
        },
        rate_label() {
            return this.display_filled_rate ? '진행률' : '제출률';
        },
        sort_step() {
            return SORT_STEPS[this.sorted] || SORT_STEPS.sort;
        },
        // 종합 표 순서 — 저장소 배열은 그대로 두고 사본을 정렬한다. 지금 보기(제출률 · 진행률)의 비율을 따르므로
        // 보기를 바꾸면 다시 정렬되고, 상세보기 목록 · 다른 탭으로 순서가 새지 않는다
        sorted_target_companies() {
            const list = [...this.temp_target_companies];
            if (this.sorted !== 'sort-down' && this.sorted !== 'sort-up') return list;
            const rates = new Map(list.map(x => [x.company_id, this.totalRate(x.company_id)]));
            const dir = this.sorted === 'sort-down' ? -1 : 1;
            return list.sort((a, b) => (rates.get(a.company_id) - rates.get(b.company_id)) * dir);
        },
        // 표 최소 폭 = 폭을 정한 칸의 합(No. 56 · 프로젝트 코드 160 · 상태 88 · 날짜 100×3 · 비율 200 · 부문 64×N) + 기업명 최소 220.
        // 부문 4개면 제출률 1280 · 진행률 980 — 1366 화면 본문(약 1334) 안. 더 좁으면 가로 스크롤
        table_min_width() {
            const fixed = 56 + 160 + 88 + 200 + (this.display_filled_rate ? 0 : 3 * 100);
            return `${fixed + 220 + this.category_names.length * 64}px`;
        }
    },
    async created() {
        await this.loadProgress();
    },
    beforeDestroy(){
        this.update_nice_service_status([]);
        this.update_nice_service_status_loaded(false);
    },
    methods:{
        ...mapMutations('industry_campaigns', ['update_nice_service_status', 'update_nice_service_status_loaded']),
        ...mapActions('industry_campaigns', ['readNiceServiceStatus', 'readFilledRate', 'readProgressRate']),
        async loadProgress() {
            this.load_error = '';
            this.is_data_loaded = false;
            try {
                await Promise.all([
                    this.readNiceServiceStatus({campaign_id: this.campaign_id}),
                    this.readFilledRate({campaign_id: this.campaign_id}),
                    this.readProgressRate({campaign_id: this.campaign_id}),
                    this.$store.dispatch('readTemplateTree',{template_code:this.template_code, is_previous:false})
                ]);
                this.category_names = Array.from(this.template_contents.map(x => x.question_name));
                this.local_template_tree_contents_original = this.template_contents;
                this.is_data_loaded = true;
            } catch (error) {
                if (error?.response?.status === 401) return;
                this.load_error = getErrorMessage(error, '진행현황을 불러오지 못했습니다.');
            }
        },
        getTotalFilledRate(company_id){
            let jdx = this.total_filled_rate.findIndex(x => x.company_id==company_id);
            if(jdx >-1){
                return this.total_filled_rate[jdx].filled_rate*100;
            }
            else return 0;
        },
        getCategoryFilledRate(company_id){
            let by_company = this.category1_filled_rate.filter(y => y.company_id == company_id);
            let temp_obj = {};
            by_company.forEach(z => {
                temp_obj[z.category1_name] = z.filled_rate*100; 
            });
            return temp_obj;
        },
        getTotalProgressRate(company_id){
            let jdx = this.total_progress_rate.findIndex(x => x.company_id==company_id);
            if(jdx >-1){
                return this.total_progress_rate[jdx].completed_rate*100;
            }
            else return 0;
        },
        getCategoryProgressRate(company_id){
            let by_company = this.category1_progress_rate.filter(y => y.company_id == company_id);
            let temp_obj = {};
            by_company.forEach(z => {
                temp_obj[z.category1_name] = z.completed_rate*100; 
            });
            return temp_obj;
        },
        // 보기(제출률 · 진행률)에 맞는 전체 · 부문별 비율
        totalRate(company_id) {
            return this.display_filled_rate ? this.getTotalFilledRate(company_id) : this.getTotalProgressRate(company_id);
        },
        categoryRate(company_id) {
            return this.display_filled_rate ? this.getCategoryFilledRate(company_id) : this.getCategoryProgressRate(company_id);
        },
        // 버튼 조작은 push(뒤로가기로 이전 보기), 검색 입력은 replace
        changeViewQuery(patch, replace = false) {
            const query = {...this.$route.query, ...patch};
            Object.keys(patch).forEach(key => query[key] === undefined && delete query[key]);
            if (JSON.stringify(query) === JSON.stringify(this.$route.query)) return;
            this.$router[replace ? 'replace' : 'push']({query}).catch(() => {});
        },
        statusLabel(status_code) {
            const labels = {
                requested: '신청됨', in_progress: '답변중', in_reprogress: '보완중',
                in_assessment: '평가중', completed: '완료', canceled: '취소'
            };
            return labels[status_code] || status_code;
        },
        statusTone(status_code) {
            return PROGRESS_TONE[STATUS_SHORT[status_code]] || 'secondary';
        },
        selectCompany(company_item){
            this.changeViewQuery({cpn: String(company_item.company_id)});
            this.re_total += 1;
            this.re_category += 11;
        },
        checkCompleted(node){
            if(node.children && node.children.length) return '';

            if(node.is_completed == 'true') { return '완료'; }
            else return '진행중';
        },
        changeProgressMode(mode){
            this.$nextTick(()=>{
                this.re_total += 2;
                this.re_category += 10;
            });
            this.display_filled_rate = mode;
        },
        // 기업 기록에는 비율 필드(total_progress · total_filled_rate)가 없어 전에는 순서가 그대로였다 —
        // 이제 칸에 보이는 비율로 정렬한다(sorted_target_companies)
        toggleSorted(mode){
            this.sorted = mode;
        },
        getNiceServiceStatus(company_id){
            let idx = this.nice_services_status.findIndex(x => x.company_id == company_id);
            if(idx > -1){
                return this.nice_services_status[idx].status_code;
            }else return '-';
        },
        getNiceServiceTimeStamp(company_id, status_str, format = 'YY-MM-DD HH:mm'){
            let idx = this.nice_services_status.findIndex(x => x.company_id == company_id);
            let temp_ts = status_str+'_ts';
            if(idx > -1){
                if(this.nice_services_status[idx][temp_ts]!=null&&this.nice_services_status[idx][temp_ts]!='NaT'){
                    return this.formatDate(this.nice_services_status[idx][temp_ts], format);
                }else return '-';                
            }else return '-';
        },
        category_name_to_code(category_name){
            if (category_name=='환경') return 'E';
            if (category_name=='인권 및 노동') return 'S';
            if (category_name=='윤리 및 지배구조') return 'G';
            if (category_name=='제품 및 서비스 책임') return 'R';
            return category_name;
        }
    }
};
</script>

<style scoped>
.total-progress-charter {
    max-width: 150px;
}
.total-progress-dounut-inner{
    text-align: center;
}
.progress-charter {
    max-width: 130px;
}
.progress-dounut-inner{
    text-align: center;
}
.thin-progress, .category-progress {
    background-color: rgba(150, 150, 150, 0.2)!important;
}

.thin-progress > .progress-bar {
    background-color: var(--blue);
}

.category-progress > .progress-bar {
    background-color: var(--blue4);
}

.overall-company-progress > .progress-bar{
    background-color: var(--blue);
}

.on-track{
    color: var(--gray-600)!important;
    font-size: 0.9rem;
    line-height: 1.2;
}
.on-completed {
    color: var(--blue)!important;
    font-size: 0.9rem;
    line-height: 1.2;
}
.node-level-1 {
    background-color: var(--gray-300);
    font-weight: 600;
}
.node-level-2 {
    background-color: var(--gray-200);
    font-weight: 500;
}
.node-level-1-sub {
    padding-left: 1.5rem!important;
}
.node-level-2-sub {
    padding-left: 2.75rem!important;
}
.node-level-3-sub {
    padding-left: 2.75rem!important;
}
/* .active {
    border:1px solid var(--blue)!important;
    color: var(--blue)!important;
} */

.top-tri{
    position: relative;
    margin-top: 17px;
}
.top-tri::before{
    position: absolute;
    top: -17px;
    height: 0;
    width: 0;
    left: 0;
    border: 7px solid transparent;
    border-bottom-color: var(--blue);
    content: "";
}
</style>

<style>
/* 표(table)는 b-table-simple 안쪽이라 scoped 가 닿지 않는다. 최소 폭은 부문 수로 계산한 값(table_min_width)을 wrapper 의 CSS 변수로 받는다 */
.campaign-progress-table {
    min-width: var(--campaign-progress-min-width, 1280px);
}
</style>
